import { create } from 'zustand';
import api from '../api/axios';

const useSettingsStore = create((set, get) => ({
	isMaintenance: false,
	lastChecked: null,
	async checkMaintenance() {
		try {
			const res = await api.get('/status');
			console.log('res', res.maintenance);
			set({
				isMaintenance: res.maintenance === true,
				lastChecked: Date.now(),
			});
		} catch (e) {
			console.error('Status check failed', e);
		}
	},
}));

export default useSettingsStore; 